<template>
  <welcome-component
    :grey-background="true"
    title="Add New Client"
    :newClientCreating="true"
  />
</template>

<script>
  import WelcomeComponent from '../welcome/Index'
  export default {
    name: 'new-advertiser-component',
    components: {WelcomeComponent},
    data: () => {
      return {
        dialog: false
      }
    }
  }
</script>

<style scoped>

</style>
